import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const useStyles = makeStyles(() => ({
  metaRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '10px',
    marginBottom: '12px',
    fontSize: '0.72rem',
    color: '#666666',
    lineHeight: 1.35,
  },
  metaRef: {
    textAlign: 'right',
    wordBreak: 'break-all',
    maxWidth: '55%',
  },
}));

export default function OrderTransactionMeta({ order }) {
  const classes = useStyles();
  if (!order) return null;
  const ref = order.gateway_id || order.id;
  return (
    <div className={classes.metaRow}>
      <span>{moment(order.created_at).format('DD/MM/YYYY [às] HH[h]mm')}</span>
      <span className={classes.metaRef}>{ref}</span>
    </div>
  );
}
